import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { AnalyticsEvent, analyticsService } from '~/services/analytics';
import navigationHistory from '~/services/NavigationHistory';

export const useNavigationTracking = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    navigationHistory.push(pathname);
    analyticsService.track(AnalyticsEvent.PAGE_VIEW_BI, {
      path: pathname,
      title: document.title,
    });
    if (!pathname.includes('/p')) {
      analyticsService.track(AnalyticsEvent.PIXEL_PAGE_VIEW, {});
    }
  }, [pathname]);

  return {
    canGoBack: navigationHistory.canGoBack(),
    canGoForward: navigationHistory.canGoForward(),
    getPreviousPath: () => navigationHistory.getPreviousPath(),
    getCurrentPath: () => navigationHistory.getCurrentPath(),
    getHistoryStack: () => navigationHistory.getHistoryStack(),
  };
};
